import { Component, OnInit, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import swal from 'sweetalert/dist/sweetalert.min.js';
import { coerceStringArray } from '@angular/cdk/coercion';
import { Row } from 'jspdf-autotable';

@Component({
  selector: 'app-regis',
  templateUrl: './regisorder.component.html',
  styleUrls: ['./regisorder.component.css']
})
export class RegisorderComponent implements OnInit {
  @ViewChild('navRagamTontonantab', { static: false }) navRagamTontonantab: ElementRef;
  @ViewChild('navPaketInternettab', { static: false }) navPaketInternettab: ElementRef;
  @ViewChild('navBonusBerlangganantab', { static: false }) navBonusBerlangganantab: ElementRef;
  @ViewChild('navBonustab', { static: false }) navBonustab: ElementRef;

  public prod : number = 0; 
  public period : number = 0;
  public addon : number = 0;

  constructor(
    private fb: FormBuilder,
    private mapsAPILoader: MapsAPILoader,
    public rest:ApiContentService,
    private route:ActivatedRoute,
    private router: Router
  ) { }

  submitted = false
  loadingIcon = {
    invalid: false,
    prev: false,
    // prevTab: 'navPaketInternettab',
    next: false,
    nextTab: 'navPaketInternettab',
    ragam: 'Paket Internet',
    showCheckout: false,
    showBtnCheckout: false,
  };
  link = false
  siska = true
  nexto = true
  wajib = false
  addonlink = false
  data_alacarte:any = []
  data_product:any = []
  data_discount:any = []
  data_bonus:any = []
  prospekindex:any
  data_prospek:any = {}
  prospek:any = {}
  product:any = {}
  discount:any = {}
  total:any = 0
  dpchoose:any = false
  dt:number=0
  choose_product:any = {}
  choose_alacarte:any = []
  choose_discount:any = []
  choose_bonus:any = []
  lo_order:any = []
  lo_discount:any = []
  lo_bonus:any = []
  price_total:number = 0
  price_origin:number = 0
  price_discount:number = 0
  price_materai:number = 0
  agreeTermcondition:any = false
  data_listperiod:any = [1,3,6,12]

  ngOnInit(): void {
    this.prospekindex = this.route.snapshot.params.prospekindex
    this.route.queryParams.subscribe((queryParam)=>{
      this.prod = queryParam.prod;
      this.period = queryParam.period;
      this.addon = queryParam.addon; 
      //this.period = queryParam.period; 
      //console.log(queryParam);
      //console.log(this.prod);
    });

    //this.loadingIcon.prev = false
    console.log("tea")
    // swal({
    //   title: "Sukses!",
    //   text: "tea",
    //   icon: "success",
    // });
    // this.getProductalcrt()

    if(!(this.period == null)){
    this.getProduct(this.period);
    }else{
    this.getProduct(1);
    }
    
    this.getProspeksummary()
  }


  choosePeriod(dt:any) {
   // dt.choose = true
    //console.log(dt); 
    this.getProduct(dt);
    //this.choosePeriod = dt;
    
    let id = this.route.snapshot.paramMap.get('prod');

    console.log(id);
  }

  getProductalcrt(dp:any){
    console.log(dp);
    const postData = {
      "product_id": dp.product_id,
      "channel_type": 2 //2.sgs
    }
    this.rest.listProductalacartesgs(postData)
      //console.log(postData)
      .subscribe((response: any) => {
        this.data_alacarte = response.data
        this.choose_alacarte=[]

        
        //this.choose_alacarte = []
          // da.data_alacarte = response.data
        this.data_alacarte.forEach((row:any) => {
          //console.log(row)
          row.choose = false
          
          if(row.wajib_select == 1){
            row.choose = true
            //this.wajib = true

          }

          if(!(this.addon == null)){
            if(row.id == this.addon){
               //.choose = true
               // row.choose = true
              this.addonlink = true
              row.choose = true
              this.choose_alacarte.push(
                {
                  'iptv_name': row.iptv_name,
                  'iptv_id': row.iptv_id,
                  'product_id': row.product_id,
                  'group_id': row.group_id,
                  'price': row.price
                }
              )
            }else{
              this.addonlink = true
            }
          }

          this.lo_order.forEach((rowlo:any) => {
            if(row.product_id == rowlo.product_id && rowlo.order_type == 3){
              row.choose = true
              // console.log(row)

              this.choose_alacarte.push(
                {
                  'iptv_name': row.iptv_name,
                  'iptv_id': row.iptv_id,
                  'product_id': row.product_id,
                  'group_id': row.group_id,
                  'price': row.price
                }
              )
            }
          })

          row.modalAction = 'modalAction'+row.product_id
          row.data_alacarte_detail = []
          let dataimage = {
            // 'ipp_type': 1,
            // 'category': row.category,
            // 'product_id': row.product_id
            'image_id': row.image_id
          }
          this.rest.getImageproduct(dataimage)
            .subscribe((response: any) => {
              if(response.status){
                row.product_image = response.data
              }
          });
        });

          // //load alacarte
          // this.data_alacarte.forEach((row:any) => {
                
          //   this.lo_order.forEach((rowlo:any) => {
          //     if(row.product_id == rowlo.product_id && rowlo.order_type == 3){
          //       row.choose = true
          //       // console.log(row)
          //       this.choose_alacarte.push(
          //         {
          //           'iptv_name': row.iptv_name,
          //           'iptv_id': row.iptv_id,
          //           'product_id': row.product_id,
          //           'group_id': row.group_id,
          //           'price': row.price
          //         }
          //       )
          //     }
          //   })

          // })

        }
      );
  }

  getListproductdtl(da:any){
    da.data_alacarte_detail = []
    const params = {}
    params['image_id'] = da.image_id
    let datapost = params
    console.log(datapost); 

    this.rest.getListimgproddtl(datapost)
    .subscribe((restlistimg: any) => {
        if(restlistimg.status == true){
          da.data_alacarte_detail = restlistimg.data
          da.data_alacarte_detail.forEach((row:any) => {
            row.product_image = ""
            let dataimage = {
              'image_dtl_id': row.id
            }
            this.rest.getImageproductdet(dataimage)
              .subscribe((resimg: any) => {
                if(resimg.status == true){
                  row.product_image = resimg.data
                }
            });
          });
        }
        //console.log(da)
      }
    );
  }

  getProduct(dt:any){
    const params = {}
    params['customer_type'] = 1
    params['category'] = 11
    params['channel_type'] = 2 //2.sgs
    params['prospek_index'] = this.prospekindex
    params['period'] = dt 
    //params['prod'] = this.prod
    //params['period'] = 1
    let datapost = params
    //console.log("siska");
    //console.log(this.data_listperiod);
    

    this.rest.listProductsgs(datapost)
      .subscribe((response: any) => {
        this.data_product = response.data
        this.data_product.forEach((row:any) => {
          row.choose = false
          if(!(this.prod == null)){
            if(row.id == this.prod){
              this.chooseProduct(row);
              row.choose = true
            }else{
              this.link = true;              
            }
          }
        
          let dataimage = {
            'image_id': row.image_id
          }

          this.rest.getImageproduct(dataimage)
            .subscribe((response: any) => {
              if(response.status){
                row.product_image = response.data
              }
          });
        });
        // console.log(this.data_product);
      });

  }

  getDiscounct(dp:any){
    const params = {
      'alacarte' : this.choose_alacarte,
      'channel_type' : 2,
      'product_id' : dp.product_id,
    }
    this.rest.listDiscountregissgs(params).subscribe((response: any) => {
       // console.log(response)
        this.data_discount = response.data
        this.data_discount.forEach((row:any) => {
          row.choose = false

          if ( this.lo_discount.length != 0) {
            this.lo_discount.forEach((rowlo:any) => {
              if(row.discount_id == rowlo.discount_id){
                row.choose = true
                this.choose_discount = row
                this.getBonus(row)
              }
            })
          }

          if ( row.image_id != null ){
            let dataimage = {
              'image_id': row.image_id
            }
            this.rest.getImageproduct(dataimage)
              .subscribe((response: any) => {
                if(response.status){
                  row.product_image = response.data
                }
            });
          }
        });
        // console.log(this.data_discount);

      });

  }

  getBonus(dd:any){
    const params = {}
    params['channel_type'] = 2 // SGS
    // params['product_id'] = dd.product_id
    // params['complement_id'] = dd.period_total
    params['prospek_index'] = this.prospekindex
    let datapost = params
    
    this.rest.listBonussgs(datapost)
    .subscribe((response: any) => {
        console.log(response.data)
        this.data_bonus = response.data
        this.data_bonus.forEach((row:any) => {
          row.choose = false
          row.modalAction = 'modalAction'+row.bonus_id
          row.data_bonus_detail = []

          if ( this.lo_bonus.length != 0) {
            this.lo_bonus.forEach((rowlo:any) => {
              if(row.bonus_id == rowlo.bonus_id){
                row.choose = true
                this.choose_bonus = row
              }
            })
          }

          // row['modalAction'] = 'modalAction'+row.bonus_id
          // row.edit_effective_from = this.effective_from
          // row.edit_effective_to = this.effective_to
          if(row.image_id != null){
            let dataimage = {
              'image_id': row.image_id
            }
            this.rest.getImageproduct(dataimage)
              .subscribe((response: any) => {
                if(response.status){
                  row.product_image = response.data
                }
            });
          }
        });
        // this.chooseBonus(this.data_bonus[0])
    });

  }

  getListbonusdtl(db:any){
    
    db.data_alacarte_detail = []
    const params = {}
    params['image_id'] = db.image_id
    let datapost = params
    
    this.rest.getListimgproddtl(datapost)
    .subscribe((restlistimg: any) => {
        if(restlistimg.status == true){
          db.data_bonus_detail = restlistimg.data
          db.data_bonus_detail.forEach((row:any) => {
            row.product_image = ""
            let dataimage = {
              'image_dtl_id': row.id
            }
            this.rest.getImageproductdet(dataimage)
              .subscribe((resimg: any) => {
                if(resimg.status == true){
                  row.product_image = resimg.data
                }
            });
          });
        }
        // console.log(db)
      }
    );
  }


  chooseAlacarte(da:any,dpchoose:any){
    console.log(dpchoose);
    //console.log("woi")
    //return da;
    da.choose = true
    this.total = 0
    const price_dp = (this.choose_product.price !== undefined ? (this.choose_product.price+(this.choose_product.price*0.1)) : 0)
    this.choose_alacarte = [];
    console.log(da); 

    //this.da= true
  // console.log(this.data_alacarte);

    this.total = (Math.trunc(price_dp))
    this.data_alacarte.forEach((element:any) => {
      if(element.choose == true){
        const price_da = element.price+element.price*0.1
        this.total = (Math.trunc(price_da)) + this.total
        this.choose_alacarte.push(
          {
            'iptv_name': element.iptv_name,
            'iptv_id': element.iptv_id,
            'product_id': element.product_id,
            'group_id': element.group_id,
            'price': element.price
          }
        )
      }
      
    })

    // const params = {}
    // params['prospekindex'] = this.prospekindex
    // params['alacarte'] = this.choose_alacarte

    // params['price'] = this.total

    // let datapost = params

    // this.rest.setProspekorder(datapost)
    //   .subscribe((response: any) => {
    //     console.log(response)
    //   }
    // );
  }

  unchooseAlacarte(da:any){
    da.choose = false
    this.total = 0
    const price_dp = (this.choose_product.price !== undefined ? (this.choose_product.price+(this.choose_product.price*0.1)) : 0)
    this.choose_alacarte = [];

    this.total = (Math.trunc(price_dp))
    this.data_alacarte.forEach((element:any) => {
      if(element.choose == true){
        const price_da = element.price+element.price*0.1
        this.total =  (Math.trunc(price_da)) + this.total
        this.choose_alacarte.push(
          {
            'iptv_name': element.iptv_name,
            'iptv_id': element.iptv_id,
            'product_id': element.product_id,
            'group_id': element.group_id,
            'price': element.price
          }
        )
      }
    })

    // const params = {}
    // params['prospekindex'] = this.prospekindex
    // params['alacarte'] = this.choose_alacarte

    // params['price'] = this.total

    // let datapost = params

    // this.rest.setProspekorder(datapost)
    //   .subscribe((response: any) => {
    //     console.log(response)
    //   }
    // );
  }

  chooseProduct(dp:any){
    console.log(dp)
    console.log("tea2")
    this.data_product.forEach((row:any) => {
      row.choose = false
      if(row.id == this.prod){
        row.choose = true

      }
    });
    dp.choose = true


    //console.log(dp.choose)
    this.dpchoose = true
    this.total = 0
    
    if(this.dpchoose = true){
      this.nexto = false
    }

    this.choose_product = {
      "hsi_name": dp.hsi_name,
      "hsi_id": dp.hsi_id,
      "product_id": dp.product_id,
      "price": dp.price,
    }
    const price_dp = this.choose_product.price+(this.choose_product.price*0.1)
    // this.choose_alacarte = [];

    this.total = (Math.trunc(price_dp))
    this.data_alacarte.forEach((element:any) => {
      if(element.choose == true){
        const price_da = element.price+element.price*0.1
        this.total =  (Math.trunc(price_da)) + this.total
        // this.choose_alacarte.push(
        //   {
        //     'iptv_name': element.iptv_name,
        //     'iptv_id': element.iptv_id,
        //     'product_id': element.product_id,
        //     'price': element.price
        //   }
        // )
      }
    })
    
    // const params = {}
    // params['prospekindex'] = this.prospekindex
    // params['main'] = this.choose_product

    // params['price'] = this.total

    // let datapost = params

    // this.rest.setProspekorder(datapost)
    //   .subscribe((response: any) => {
    //     console.log(response)
    //     if ( response.status ) {
    //       this.getDiscounct(dp)
    //     }else{

    //     }
    //   }
    // );
  }
  
  chooseDiscount(dd:any){
    console.log(dd)
    this.data_discount.forEach((row:any) => {
      row.choose = false
    });
    dd.choose = true
    this.choose_discount = dd
    console.log(this.choose_discount)

    // const params = dd
    // params['prospekindex'] = this.prospekindex
    // params['channel_type'] = 2
    // this.rest.setDiscount(params).subscribe((response: any) => {
    //     console.log(response)
    //   }
    // );
  }
  
  chooseBonus(db:any){
    this.data_bonus.forEach((row:any) => {
      row.choose = false
    });
    db.choose = true
    this.choose_bonus = db
    console.log(this.choose_bonus)

    // const params = db
    // params['prospekindex'] = this.prospekindex
    // params['channel_type'] = 2
    // this.rest.setBonus(params).subscribe((response: any) => {
    //     console.log(response)
    //   }
    // );
  }



  public nextTab(tab:any){
    this.loadingIcon.next = true
    setTimeout(() => {
      // this.opnNexttab()

      if(tab == 'navPaketInternettab'){
        this.siska = false
        console.log(this.siska)
        //Product
        this.loadingIcon.showBtnCheckout = false
        this.data_discount = []
        this.data_bonus = []    

        const params = {}
        params['prospekindex'] = this.prospekindex
        params['main'] = this.choose_product
        params['price'] = this.total
    
        let datapost = params
        
        console.log(this.dpchoose);
        //console.log("nexto"); 
        console.log(this.nexto); 
        if(this.dpchoose == true){
          this.nexto = false
        }



        //  if(this.choose_product == null){
        //    this.nexto = true
        //  }

        this.rest.setProspekorder(datapost)
          .subscribe((response: any) => {
            console.log(response)
            if ( response.status ) {
              this.loadingIcon.next = false
              this.navRagamTontonantab.nativeElement.click();
              this.loadingIcon.nextTab = 'navRagamTontonantab'
              this.loadingIcon.ragam = 'Ragam Tontonan'
              // this.navBonusBerlangganantab.nativeElement.click();
              // this.loadingIcon.nextTab = 'navBonusBerlangganantab'
              // this.loadingIcon.ragam = 'Bonus Berlangganan'
              // this.getDiscounct(this.choose_product)
              this.getProductalcrt(this.choose_product)
            }else{
    
            }
          }
        );

      } else if(tab == "navRagamTontonantab"){
        
        //Alacarte
        this.loadingIcon.showBtnCheckout = false
        this.data_discount = []
        this.data_bonus = []  
        console.log("siska")

        console.log(this.data_alacarte)

        this.data_alacarte.forEach((element:any) => {
          if(element.wajib_select == 1){
            const price_da = element.price+element.price*0.1
            this.total = (Math.trunc(price_da)) + this.total
            this.choose_alacarte.push(
              {
                'iptv_name': element.iptv_name,
                'iptv_id': element.iptv_id,
                'product_id': element.product_id,
                'group_id': element.group_id,
                'price': element.price
              }
            )
          }    
        })
        
        
        const params = {}
        params['prospekindex'] = this.prospekindex
        params['alacarte'] = this.choose_alacarte
        params['price'] = this.total

        let datapost = params

        // if(this.choose_alacarte == null){
        //   this.loadingIcon.next = false
        // }
        console.log(datapost);
        this.rest.setProspekorder(datapost)
          .subscribe((response: any) => {
            console.log(response)
            this.loadingIcon.next = false
            //this.navBonusBerlangganantab.nativeElement.click();
            //this.loadingIcon.nextTab = 'navBonusBerlangganantab'
            //this.loadingIcon.ragam = 'Bonus Berlangganan'
            //this.getDiscounct(this.choose_product)
            this.getProspeksummary()
          }
        );

      } else if(tab == 'navBonusBerlangganantab'){

        //discount
        this.data_bonus = []  

        const params = this.choose_discount
        params['prospekindex'] = this.prospekindex
        params['channel_type'] = 2
        this.rest.setDiscount(params).subscribe((response: any) => {
            console.log(response)
            this.loadingIcon.next = false
            this.navBonustab.nativeElement.click();
            this.loadingIcon.nextTab = 'navBonustab'
            this.loadingIcon.ragam = 'Bonus'
            this.getBonus(this.choose_discount)
          }
        );
      } else if(tab == 'navBonustab'){

        //bonus
        const params = this.choose_bonus
        params['prospekindex'] = this.prospekindex
        params['channel_type'] = 2

        this.rest.setBonus(params).subscribe((response: any) => {
            console.log(response)
            if (response.status == true) {
              // this.loadingIcon.next = false
              this.getProspeksummary()
            }
          }
        );
      } 
    }, 500);
  }

  public prevTab(tab:any){
    this.loadingIcon.prev = true
     //console.log("gagagaga")
    setTimeout(() => {
      //console.log("prev paketinternet")
      // this.opnNexttab()
      if(tab == 'navPaketInternettab'){
        //this.loadingIcon.prev = true

        //this.siska = true
        
        //Product
        // this.loadingIcon.showBtnCheckout = false
        // this.data_discount = []
        // this.data_bonus = []    

        // const params = {}
        // params['prospekindex'] = this.prospekindex
        // params['main'] = this.choose_product
        // params['price'] = this.total
    
        // let datapost = params
    
        // this.rest.setProspekorder(datapost)
        //   .subscribe((response: any) => {
        //     console.log(response)
        //     if ( response.status ) {
        //       this.loadingIcon.prev = false
        //       this.getProductalcrt(this.choose_product)
        //     }else{
    
        //     }
        //   }
        // );

      } else if(tab == "navRagamTontonantab"){
        this.siska = true
        //Alacarte
        // this.loadingIcon.showBtnCheckout = false
        // this.data_discount = []
        // this.data_bonus = []  
        
        // const params = {}
        // params['prospekindex'] = this.prospekindex
        // params['alacarte'] = this.choose_alacarte
        // params['price'] = this.total

        // let datapost = params

        // console.log(datapost)
        // this.rest.setProspekorder(datapost)
        //   .subscribe((response: any) => {
        //     console.log(response)

            this.loadingIcon.prev = false
            this.navPaketInternettab.nativeElement.click();
            this.loadingIcon.nextTab = 'navPaketInternettab'
            this.loadingIcon.ragam = 'Paket Internet'
        //     this.getDiscounct(this.choose_product)
        //   }
        // );

      } else if(tab == 'navBonusBerlangganantab'){

        //discount
        // this.data_bonus = []  

        // const params = this.choose_discount
        // params['prospekindex'] = this.prospekindex
        // params['channel_type'] = 2
        // this.rest.setDiscount(params).subscribe((response: any) => {
        //     console.log(response)
            this.loadingIcon.prev = false
            this.navRagamTontonantab.nativeElement.click();
            this.loadingIcon.nextTab = 'navRagamTontonantab'
            this.loadingIcon.ragam = 'Ragam Tontonan'
        //     this.getBonus(this.choose_discount)
        //   }
        // );
      } else if(tab == 'navBonustab'){

        //bonus
        // const params = this.choose_bonus
        // params['prospekindex'] = this.prospekindex
        // params['channel_type'] = 2

        // this.rest.setBonus(params).subscribe((response: any) => {
        //     console.log(response)
        //     if (response.status == true) {
              this.loadingIcon.prev = false
              this.navBonusBerlangganantab.nativeElement.click();
              this.loadingIcon.nextTab = 'navBonusBerlangganantab'
              this.loadingIcon.ragam = 'Bonus Berlangganan'
        //       this.getProspeksummary()
        //     }
        //   }
        // );
      } 
    }, 500);
  }


  getProspeksummary() {

    const params = {
      'prospekindex' : this.prospekindex
    }

    this.rest.getProspeksummary(params).subscribe((response: any) => {
      //console.log("siska3")
        //console.log(response)
        if (response.status == true) {
          if(response.data.order.length != 0){
            this.loadingIcon.showCheckout = true
            this.loadingIcon.showBtnCheckout = true
            // this.prospek = response.data.prospek
            // this.lo_order = response.data.order
            // this.lo_discount = response.data.discount
            // this.lo_bonus = response.data.bonus
            // this.price_total = response.data.price_total
            // this.price_origin = response.data.price_origin
            // this.price_discount = response.data.price_discount
            // this.price_materai = response.data.price_materai
            this.data_prospek = response.data
            
            setTimeout(() => {
  
              //load product
              this.data_product.forEach((row:any) => {
  
                this.lo_order.forEach((rowlo:any) => {
                  if(row.product_id == rowlo.product_id && rowlo.order_type == 1){
                    row.choose = true
                    this.choose_product = {
                      "hsi_name": row.hsi_name,
                      "hsi_id": row.hsi_id,
                      "product_id": row.product_id,
                      "price": row.price
                    }
                    this.getDiscounct(row)
                    this.getProductalcrt(row)
                  }
                })
  
              })

              // //load alacarte
              // this.data_alacarte.forEach((row:any) => {
                
              //   this.lo_order.forEach((rowlo:any) => {
              //     if(row.product_id == rowlo.product_id && rowlo.order_type == 3){
              //       row.choose = true
              //       // console.log(row)
              //       this.choose_alacarte.push(
              //         {
              //           'iptv_name': row.iptv_name,
              //           'iptv_id': row.iptv_id,
              //           'product_id': row.product_id,
              //           'group_id': row.group_id,
              //           'price': row.price
              //         }
              //       )
              //     }
              //   })
  
              // })
              
            }, 3000);
          }
        }
        this.loadingIcon.next = false
        // this.data_order = response.data.order;
        // this.data_bonus = response.data.bonus;
        // this.data_discount = response.data.discount;
      }
    );
  }

  setChecktermcondition(event:any){
    this.agreeTermcondition = event.target.checked;
    //console.log(this.agreeTermcondition)
  }
  setCancel(){
    this.loadingIcon.showCheckout = false
    this.siska = true
    setTimeout(() => {
      this.loadingIcon.nextTab = 'navPaketInternettab'
      this.navPaketInternettab.nativeElement.click();
    }, 1000);
  }
  setSubmit(){
    //console.log(this.agreeTermcondition)

    //set sumbit
    const params = {
      'status_id' : 10, //10. submited
      'prospekindex' : this.prospekindex,
      'price_total' : this.data_prospek.price_total
    }

    this.rest.setChangestatus(params).subscribe((response: any) => {
        //console.log(response)
        if (response.status == true) {
          // swal({
          //   title: "Final Transaction!",
          //   text: "Terimakasih anda telah mengisi Form Berlangganan. Kami akan segera melakukan Submit Data anda dan Kami akan menghubungi kamu terkait penjadwalan pemasangan. Terimakasih atas Kepercayaanya  menggunakan Layanan MNC Play",
          //   icon: "success",
          //   closeOnClickOutside: false
          // });
          swal({
            title: "Final Transaction!",
            text: "Halo! Makasih udah milih MNC Play buat jadi solusi pasti untuk eksplorasi duniamu.\n Proses pengisian data kamu sudah berhasil.\n Tinggal selangkah lagi nih buat mulai keseruan bersama! Tunggu proses verifikasinya maksimal 3x24 jam dari sekarang ya.\n Sambil menunggu, download aplikasi Vision+ dulu yuk, biar bisa nikmatin tayangan lewat gadget!\n Vision+, aplikasi paling kece buat nonton TV kapan pun dan dimana pun.\n Cek selengkapnya di http://onelink.to/visionplusid",
            icon: "success",
            closeOnClickOutside: false,
            button: {confirm:true,text:"onelink.to/visionplusid"},
          }).then((confirmrsp:any)=>{ 
            if(confirmrsp){
              window.open("http://onelink.to/visionplusid")
            }
          });
          setTimeout(() => {
            this.router.navigate(['regis']);
          }, 5000);
        }else{
          swal({
            title: "Terjadi Kesalahan!",
            text: response.message,
            icon: "error",
          });
        }
      }
    );
  }

  private opnNexttab(): void {
    this.navPaketInternettab.nativeElement.click();
  }


  onNext(){

    // this.rest.setDataprospek(this.regis).subscribe((response:any) => {
    //   console.log(response);

    //   if (response.status == true) {
        
    //     // Modal not work
    //     alert(response.message + "\nMohon selanjutnya isi data diri dengan benar dan lengkap\n\nTerimakasih!")
    //     this.router.navigate(['regis2/', response.data.prospekindex]);

    //   } else {
    //     // console.log('not cover');
    //     alert(response.message + "\n\nTerimakasih!")      }
    // });
  }
  updateprofilecust(){
    this.submitted = false;
    //alert(this.prospekindex);
    // this.ngOnInit();
    this.router.navigate(['updateprofile/'+this.prospekindex]);
  }

  onReset(){
    this.submitted = false;
    // this.ngOnInit();
    this.router.navigate(['regis']);
  }  
}
// function da(da: any, row: any) {
//   throw new Error('Function not implemented.');
// }

